export default __webpack_public_path__ + "assets/img/background_tile.5da0b78df8f24b73bd47cb66d7d0d2f3.svg";